module.exports = __webpack_public_path__ + "static/media/sline.a3d09dff.svg";